import { useCallback } from 'react';
import { LandingNav } from './LandingNav';
import { Hero } from './sections/Hero';
import { Features } from './sections/Features';
import { HowItWorks } from './sections/HowItWorks';
import { Pricing } from './sections/Pricing';
import { Footer } from './sections/Footer';

export function LandingPage() {
  const scrollToSection = useCallback((sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[var(--color-app-bg)] text-[var(--color-ink)]">
      <LandingNav onScrollTo={scrollToSection} />
      <Hero onScrollTo={scrollToSection} />
      <Features />
      <HowItWorks />
      <Pricing />
      <Footer />
    </div>
  );
}
